export function ChatMessageListLoadingPlaceholder() {
  return (
    <div className="h-100 d-flex flex-column justify-content-end">
      <div className="d-flex flex-column gap-1 placeholder-glow">
        <div className="col-9 p-1 rounded-top-3 rounded-end-3 bg-chat-caller">
          <div className="placeholder col-4 x-small"></div>
          <div className="placeholder col-9"></div>
        </div>
        <div className="col-9 p-1 rounded-top-3 rounded-end-3 bg-chat-caller">
          <div className="placeholder col-3 x-small"></div>
          <div className="placeholder col-11"></div>
          <div className="placeholder col-8"></div>
        </div>
        <div className="col-9 offset-3 p-1 rounded-top-3 rounded-start-3 bg-chat-dispatcher">
          <div className="placeholder col-4 x-small"></div>
          <div className="placeholder col-9"></div>
        </div>
        <div className="col-9 offset-3 p-1 rounded-top-3 rounded-start-3 bg-chat-dispatcher">
          <div className="placeholder col-4 x-small"></div>
          <div className="placeholder col-8"></div>
        </div>
        <div className="col-9 p-1 rounded-top-3 rounded-end-3 bg-chat-caller">
          <div className="placeholder col-4 x-small"></div>
          <div className="placeholder col-10"></div>
        </div>
        <div className="placeholder w-100 mt-3" style={{ height: '50px' }}></div>
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-2">
            <div className="placeholder" style={{ width: '30px', height: '30px' }}></div>
            <div className="placeholder" style={{ width: '30px', height: '30px' }}></div>
          </div>
          <div className="placeholder" style={{ width: '30px', height: '30px' }}></div>
        </div>
      </div>
    </div>
  );
}
